import React from 'react';
import { useApp } from '../../shared/context/AppContext';
import './SettingsPanel.css';

const SettingsPanel = () => {
  const { settings, updateSetting, resetSettings } = useApp();

  return (
    <div className="settings-panel">
      <div className="settings-header">
        <h2>⚙️ Настройки приложения</h2>
        <p>Настройте параметры работы с системой анализа медицинских процессов</p>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <h3>📊 Поведение приложения</h3>
          <div className="setting-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.showGreeting}
                onChange={(e) => updateSetting('showGreeting', e.target.checked)}
              />
              <span className="checkmark"></span>
              Показывать приветственный экран
            </label>
          </div>

          <div className="setting-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.showAnimations}
                onChange={(e) => updateSetting('showAnimations', e.target.checked)}
              />
              <span className="checkmark"></span>
              Показывать анимации (кошка)
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h3>💾 Управление настройками</h3>
          <div className="settings-actions">
            <button
              className="btn btn-secondary"
              onClick={resetSettings}
              type="button"
            >
              🔄 Сбросить настройки
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
